module.exports = __webpack_public_path__ + "img/tabbed-vehicle-rows-ford.6e961b08.png";